import styled from 'styled-components'

import { type AppWrapperProps } from './AppWrapper'

export const StyledAppWrapper = styled.div<AppWrapperProps>`
  display: flex;
`
